@let choices = question().choices ?? [];

@if (isGrid()) {
  <tui-textfield tuiChevron [stringify]="stringifyChoice" [tuiTextfieldCleaner]="false">
    <input
      data-testid="radio-select"
      tuiSelect
      [formControl]="$any(control())"
      [placeholder]="placeholder()"
      [readOnly]="readOnly()" />
    <tui-data-list-wrapper *tuiDropdown new [itemContent]="choiceItem" [items]="choiceKeys()" />
  </tui-textfield>
  <ng-template #choiceItem let-key>{{ stringifyChoice(key) }}</ng-template>
} @else {
  <div class="flex flex-wrap gap-2">
    @for (choice of choices; track choice.key) {
      <label tuiBlock="m">
        <input
          ngDefaultControl
          tuiRadio
          type="radio"
          [attr.data-testid]="choice.key"
          [formControl]="control()"
          [name]="question().id"
          [readOnly]="readOnly()"
          [value]="choice.key" />
        {{ choice.value }}
      </label>
    }
  </div>
}
